@if (node().children.length > 0) {
  <!-- The row navigates; only the chevron toggles the folders beneath it. -->
  <bit-nav-group
    bitHoverRevealContainer
    icon="bwi-shared-folder"
    [text]="node().name"
    [route]="route()"
    [disableToggleOnClick]="true"
    [forceActiveStyles]="active()"
  >
    <div slot="end" bitHoverReveal>
      <ng-container *ngTemplateOutlet="options" />
    </div>
    @for (child of node().children; track child.id) {
      <vault-pinned-nav-node [node]="child" [organization]="organization()" [routes]="routes()" />
    }
  </bit-nav-group>
} @else {
  <bit-nav-item
    bitHoverRevealContainer
    icon="bwi-shared-folder"
    [text]="node().name"
    [route]="route()"
  >
    <div slot="end" bitHoverReveal>
      <ng-container *ngTemplateOutlet="options" />
    </div>
  </bit-nav-item>
}

<ng-template #options>
  <vault-collection-options-menu
    idPrefix="vault-pinned-nav"
    triggerIcon="bwi-ellipsis-h"
    triggerButtonType="side-nav"
    triggerSize="xsmall"
    [collection]="node().collection"
    [organization]="organization()"
    [unpinnable]="pinned()"
    (unpin)="unpin()"
  />
</ng-template>
